import { Component, OnInit } from '@angular/core';
import { ForecastElementDataNew, UpdateForecastElementData } from 'src/app/models/forecast/fc-validationlog-model';
import { Role } from 'src/app/models/role';
import { NotificationService } from 'src/app/services/notification.service';
import { DropdownSelectionMode, DropdownValue, DropdownValues } from 'src/app/widgets/dropdown/dropdown.component';
import { SettingsService } from '../settings.service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';

@Component({
    selector: 'app-forecast-element-adjustment',
    templateUrl: './forecast-element-adjustment.component.html',
    styleUrls: ['./forecast-element-adjustment.component.scss'],
    standalone: false
})
export class ForecastElementAdjustmentComponent implements OnInit {

	constructor(private settingsService: SettingsService, private notificationService: NotificationService) { }
	roles: Role[] = [];
	ForecastElementData: ForecastElementDataNew[] = []
	rolesDropdown: DropdownValues = new DropdownValues();
	selectedRoleId: number;


	ngOnInit() {
		this.getRoles();
	}

	private getRoles() {

		this.settingsService.getRoles()
			.subscribe(roles => {
				this.roles = roles;

				this.selectedRoleId = roles && roles.length ? roles[0].roleId : 0;
				this.prepareRolesDropdownValues();
				this.getContentPermissionsByRole();
			}, (error) => {

				this.notificationService.error("something went wrong. please try again later.");
			});
	}
	private prepareRolesDropdownValues() {
		this.rolesDropdown = new DropdownValues();
		this.rolesDropdown.selectionMode = DropdownSelectionMode.single;
		this.rolesDropdown.showClearButton = false;
		this.rolesDropdown.displayName = 'Role';
		this.rolesDropdown.values = this.roles.map(role => new DropdownValue(role.roleId, role.roleName));
	}

	private getContentPermissionsByRole() {
		if (!this.selectedRoleId) {
			this.ForecastElementData = [];

			return;
		}

		this.settingsService.ForecastElementAdjust(this.selectedRoleId)
			.subscribe(Data => {
				this.ForecastElementData = Data;

			}, (error) => {

				this.notificationService.error("something went wrong. please try again later.");
			});
	}

	roleChanged(roleId: number) {
		this.selectedRoleId = roleId;
		this.getContentPermissionsByRole();
	}

	save() {
		if (!this.selectedRoleId) {
			this.ForecastElementData = [];

			return;
		}

		let dataForecast = new UpdateForecastElementData();
		dataForecast.roleid = this.selectedRoleId;
		dataForecast.ForecastElement = [];
		this.ForecastElementData.forEach(element => {
			dataForecast.ForecastElement.push({
				ForecastElementId: element.forecastElementId,
				UserInput: element.userInput, ElementName: element.forecastElementName
			});
		});
		this.settingsService.UpdateForecastElementAdjust(dataForecast)
			.subscribe(Data => {

				if (Data != null && Data.flag != null && Data.flag > 0) {
					this.notificationService.success(Data.msg);
					this.getContentPermissionsByRole();
				} else {
					this.notificationService.error("something went wrong. please try again later.");
				}
			}, (error) => {

				this.notificationService.error("something went wrong. please try again later.");
			});
	}

	editPermission(Event) {
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);
	}
}

